import { ActionContext } from 'vuex'
import Vue from 'vue'
import util from '@/utils/classToObject'
import actionsTypes from '@/store/all-action-types'
import apiCommande from '@/api/commande'
import types from './all-mutation-types'
import { IRootState, emptyAction, actionEnsure, payloadAction } from '@/store'
import { IClientState } from './state'
import { buildStateItem } from '@/models/alo/StateItem'
import {i18n} from '@/locale/vueI18n'
import { QtyItem } from '@/models/ui/QtyItem'
import { AloForfait } from '@/models/alo/AloForfait'
import { formatCurrency } from '@/filters/currency'
import { AloPanier } from '@/models/alo/AloPanier'
import { AloAddress } from '@/models/alo/AloAddress'

export class ClientAction {
    
    public [types.CLIENT_ADD_PANIER](context: ActionContext<IClientState, IRootState>,item:QtyItem<AloForfait>) {
        return new Promise((resolve, reject) => {
            if(item.qty > 0){
                context.commit(types.CLIENT_ADD_PANIER,item)                
            }
            resolve()
        })
    }
        
    public [types.CLIENT_UPD_PANIER_ITEM_QTY](context: ActionContext<IClientState, IRootState>,{fftId,qty}:{fftId:number,qty:number}) {
        return new Promise((resolve, reject) => {
            context.commit(types.CLIENT_UPD_PANIER_ITEM_QTY,{fftId,qty})
            resolve()
        })
    }

    public [types.CLIENT_CLEAR_PANIER](context: ActionContext<IClientState, IRootState>) {
        return new Promise((resolve, reject) => {
            context.commit(types.CLIENT_CLEAR_PANIER)
            resolve()
        })
    }  

    public [types.CLIENT_CHECKOUT_REQUEST](context: ActionContext<IClientState, IRootState>,payload:AloPanier) {
        return payloadAction(context,types.CLIENT_CHECKOUT_REQUEST,types.CLIENT_CHECKOUT_SUCCESS,types.CLIENT_CHECKOUT_ERROR,apiCommande.checkout,payload)    
    } 

    public [types.CLIENT_CHECKOUT_FREE_REQUEST](context: ActionContext<IClientState, IRootState>,payload:AloPanier) {
        return payloadAction(context,types.CLIENT_CHECKOUT_FREE_REQUEST,types.CLIENT_CHECKOUT_FREE_SUCCESS,types.CLIENT_CHECKOUT_FREE_ERROR,apiCommande.checkoutfree,payload)    
    } 
    
    public [types.CLIENT_SET_PANIER_ADDRESS](context: ActionContext<IClientState, IRootState>,address:AloAddress) {
        return new Promise((resolve, reject) => {
            context.commit(types.CLIENT_SET_PANIER_ADDRESS,address)
            resolve()
        })
    } 
}

export default util.classToObject(ClientAction)
